import React from 'react'
import { Link, useLocation } from 'react-router-dom';
import withModal from '../../utils/hoc/withModal';
import { INIT_IG_AUTH_ROUTE } from '../../constants/constants';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../redux-stores/store';
import { setIntendedPath } from '../../redux-stores/slices/layoutSlice';
import { SocialAccount } from '../../types/influencer/influencerTypes';

const InfluencerActionCardModal: React.FC<{ onClose: () => void, collabPage?: boolean, socialAccount?: SocialAccount | null }> = ({ onClose, collabPage=false, socialAccount = null }) => {

    const dispatch: AppDispatch = useDispatch();
    const location = useLocation();

    return (
        <div className='mb-4'>
            <div className="menu-title p-3 mb-0">
                <h4 className="Pop">Connect with Instagram</h4>
                <button className="close-menu" onClick={onClose}>
                    <i className="fa fa-times-circle"></i>
                </button>
            </div>
            <div className="content mt-0">
                <p>To apply for this brand collab, please connect your Instagram account.</p>
                {
                    socialAccount && socialAccount?.handle &&
                    <p><b>@{socialAccount.handle}</b></p>
                }
                <Link onClick={() => dispatch(setIntendedPath(location.pathname + location.search))} to={socialAccount ? INIT_IG_AUTH_ROUTE+'?social_account_id='+socialAccount.uuid : INIT_IG_AUTH_ROUTE} className="btn btn-sm btn-primary rounded-sm w-100 mb-2">Connect with Instagram</Link>
            </div>
        </div>
    )
}

export default withModal(InfluencerActionCardModal)